import request from '../utils/request'

// 获取appid\roomNumber\userSign
export function getSign(data) {
    return request({
        url: '/patient/inquiryorder/nextRoomNumber',
        method: 'post',
        data: data
    }).then(res => res.data)
}
// 去问诊
export function goInquiry(data) {
    return request({
        url: '/patient/inquiryorder/gotoInquiry',
        method: 'post',
        data: data
    }).then(res => res.data)
}
// 取消问诊
export function cancelInquiry(data) {
    return request({
        url: '/patient/inquiryorder/cancelInquiry',
        method: 'post',
        data: data
    }).then(res => res.data)
}
// 再次联系该医生
export function againInquiry(data) {
    return request({
        url: '/patient/inquiryorder/gotoContactAgainInquiry',
        method: 'post',
        data: data
    }).then(res => res.data)
}
// 门店端向医生端推送
export function toDoctor(data) {
    return request({
        url: '/common/push/patientPushToPhysician',
        method: 'post',
        data: data
    }).then(res => res.data)
}
//过敏查询
export function irritabilityQueryList(data) {
    return request({
        url: '/rationalDict/irritability/queryList',
        method: 'post',
        data: data
    }).then(res => res.data)
}
//常jian过敏
export function getDefaultAllergy(data) {
    return request({
        url: '/rationalDict/irritability/getDefaultAllergy',
        method: 'post',
        data: data
    }).then(res => res.data)
}
//诊断拦截
export function limitDrugAudit(data) {
    return request({
        url: '/rationalProduct/limitDrugAudit',
        method: 'post',
        data: data
    }).then(res => res.data)
}
//常jian过敏
export function getRecommendAllergy(data) {
    return request({
        url: '/rationalDict/irritability/getRecommendAllergy',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}

// 查询是否ai问诊，等待时间
export function getAutoInquiryInfo(data) {
  return request({
    url: "/patient/inquiryorder/getAutoInquiryInfo",
    method: "post",
    data
  });
}

// 患者进入房间，通知接口
export function onEnterRoom(data) {
  return request({
    url: "/patient/inquiryorder/onEnterRoom",
    method: "post",
    data
  });
}

// 手动开方接口
export function autoVideoInquiryDispatch(data) {
  return request({
    url: "/patient/inquiryorder/autoVideoInquiryDispatch",
    method: "post",
    data
  });
}

// 取消开方接口
export function closePrescriptionForAutoVideoInquiry(data) {
    return request({
      url: "/physician/prescription/closePrescriptionForAutoVideoInquiry",
      method: "post",
      data
    });
  }

